/* GuruPrasadam consultation landing page — paste into assets/gp-landing.js */
// Every selector is scoped to .gp-landing so the theme header/footer are never touched.
        // ── FAQ ──
        document.querySelectorAll('.gp-landing .faq-q').forEach(q => {
            q.addEventListener('click', () => {
                const item = q.parentElement;
                const isOpen = item.classList.contains('open');
                document.querySelectorAll('.gp-landing .faq-item').forEach(i => i.classList.remove('open'));
                if (!isOpen) item.classList.add('open');
            });
        });

        // ── SMOOTH SCROLL ──
        document.querySelectorAll('.gp-landing a[href^="#"]').forEach(a => {
            a.addEventListener('click', e => {
                e.preventDefault();
                let t = null;
                if (a.getAttribute('href') !== '#') {
                    t = document.querySelector(a.getAttribute('href'));
                }
                if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });

        document.addEventListener('DOMContentLoaded', function () {

            const popup = document.getElementById('consultationPopup');
            const closeButton = document.getElementById('consultationPopupClose');

            if (!popup) return;

            /*
             * Open popup when ANY CTA button is clicked.
             * Works with the existing .btn-primary CTAs.
             */
            document.addEventListener('click', function (event) {

                const cta = event.target.closest('.gp-landing .btn-primary');

                if (!cta) return;

                /*
                 * Don't intercept submit buttons inside the popup or any consultation form.
                 */
                if (cta.closest('#consultationPopup') || cta.closest('.js-consult-form')) return;

                event.preventDefault();

                popup.classList.add('active');
                popup.setAttribute('aria-hidden', 'false');
                document.body.classList.add('consultation-popup-open');

                setTimeout(function () {
                    const firstInput = popup.querySelector('.form-input');

                    if (firstInput) {
                        firstInput.focus();
                    }
                }, 250);
            });

            function closePopup() {
                popup.classList.remove('active');
                popup.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('consultation-popup-open');
            }

            closeButton.addEventListener('click', closePopup);

            /*
             * Close when clicking outside the modal.
             */
            popup.addEventListener('click', function (event) {
                if (event.target.hasAttribute('data-close-popup')) {
                    closePopup();
                }
            });

            /*
             * Close with Escape key.
             */
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape' && popup.classList.contains('active')) {
                    closePopup();
                }
            });

            window.closeConsultationPopup = closePopup;
        });

        /*
         * Shared validation + submission for both consultation forms
         * (#form-consult and #consultationPopupForm). Rules mirror consultation.php on the API server.
         * The endpoint comes from each form's action attribute (theme editor → "API endpoint URL").
         */
        document.addEventListener('DOMContentLoaded', function () {

            const NAME_RE = /^[\p{L}][\p{L}\p{M} .'-]*$/u;

            function clean(value) {
                return String(value || '').replace(/\s+/g, ' ').trim();
            }

            function isValidWhatsapp(raw) {
                const hasPlus = raw.startsWith('+');
                let digits = raw.replace(/\D+/g, '');

                if (!hasPlus) {
                    digits = digits.replace(/^0+/, '');
                    if (digits.length === 10) digits = '91' + digits;
                }

                if (digits.startsWith('91')) return /^91[6-9]\d{9}$/.test(digits);

                return hasPlus && /^[1-9]\d{7,14}$/.test(digits);
            }

            const validators = {
                name: function (v) {
                    if (!v) return 'Please enter your name.';
                    if (v.length < 2 || v.length > 60) return 'Name must be between 2 and 60 characters.';
                    if (!NAME_RE.test(v)) return 'Name can contain only letters, spaces, dots, apostrophes and hyphens.';
                    return '';
                },
                whatsapp: function (v) {
                    if (!v) return 'Please enter your WhatsApp number.';
                    if (!isValidWhatsapp(v)) return 'Please enter a valid 10-digit WhatsApp number.';
                    return '';
                },
                facing_since: function (v) {
                    if (!v) return 'Please tell us since when you are facing this.';
                    if (v.length > 60) return 'Please keep this under 60 characters.';
                    return '';
                },
                problem: function (v) {
                    if (!v) return 'Please describe the problem you are facing.';
                    if (v.length < 3 || v.length > 500) return 'Please describe your problem in 3 to 500 characters.';
                    return '';
                }
            };

            function setFieldError(form, name, message) {
                const input = form.elements[name];
                const errorEl = form.querySelector('[data-error-for="' + name + '"]');

                if (input) {
                    input.classList.toggle('is-invalid', !!message);
                    input.setAttribute('aria-invalid', message ? 'true' : 'false');
                }
                if (errorEl) errorEl.textContent = message || '';
            }

            function validateField(form, name) {
                const input = form.elements[name];
                const message = validators[name](clean(input ? input.value : ''));
                setFieldError(form, name, message);
                return !message;
            }

            function validateForm(form) {
                let firstInvalid = null;

                Object.keys(validators).forEach(function (name) {
                    if (!validateField(form, name) && !firstInvalid) firstInvalid = form.elements[name];
                });

                if (firstInvalid) firstInvalid.focus();
                return !firstInvalid;
            }

            function setStatus(form, message, type) {
                const status = form.querySelector('.form-status');
                if (!status) return;
                status.textContent = message || '';
                status.classList.toggle('is-success', type === 'success');
                status.classList.toggle('is-error', type === 'error');
            }

            document.querySelectorAll('.js-consult-form').forEach(function (form) {
                const submitBtn = form.querySelector('button[type="submit"]');
                const submitLabel = submitBtn ? submitBtn.textContent.trim() : '';

                // Live validation: on blur, and while typing once a field has been flagged.
                Object.keys(validators).forEach(function (name) {
                    const input = form.elements[name];
                    if (!input) return;

                    input.addEventListener('blur', function () {
                        if (input.value !== '') validateField(form, name);
                    });
                    input.addEventListener('input', function () {
                        if (name === 'whatsapp') input.value = input.value.replace(/[^\d+\s-]/g, '');
                        if (input.classList.contains('is-invalid')) validateField(form, name);
                    });
                });

                form.addEventListener('submit', async function (event) {
                    event.preventDefault();
                    setStatus(form, '', null);

                    if (form.dataset.submitting === '1') return;
                    if (!validateForm(form)) return;
                    if (!form.getAttribute('action')) {
                        setStatus(form, 'Booking is not configured yet. Please message us on WhatsApp.', 'error');
                        return;
                    }

                    const payload = {
                        name: clean(form.elements.name.value),
                        whatsapp: clean(form.elements.whatsapp.value),
                        facing_since: clean(form.elements.facing_since.value),
                        problem: clean(form.elements.problem.value),
                        website: form.elements.website ? form.elements.website.value : '',
                        form_id: form.id
                    };

                    form.dataset.submitting = '1';
                    if (submitBtn) {
                        submitBtn.disabled = true;
                        submitBtn.textContent = 'Booking...';
                    }

                    try {
                        const response = await fetch(form.getAttribute('action'), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify(payload)
                        });

                        let data = {};
                        try { data = await response.json(); } catch (e) { /* non-JSON error page */ }

                        if (response.ok && data.success) {
                            form.reset();
                            Object.keys(validators).forEach(function (name) { setFieldError(form, name, ''); });
                            setStatus(form, data.message || 'Thank you! We will contact you shortly.', 'success');

                            if (form.id === 'consultationPopupForm' && typeof window.closeConsultationPopup === 'function') {
                                setTimeout(function () {
                                    window.closeConsultationPopup();
                                    setStatus(form, '', null);
                                }, 3000);
                            }
                            return;
                        }

                        if (data.errors) {
                            Object.keys(data.errors).forEach(function (name) {
                                setFieldError(form, name, data.errors[name]);
                            });
                        }
                        setStatus(form, data.message || 'Something went wrong. Please try again.', 'error');
                    } catch (err) {
                        setStatus(form, 'Network error. Please check your connection and try again.', 'error');
                    } finally {
                        form.dataset.submitting = '';
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = submitLabel;
                        }
                    }
                });
            });
        });
